import React from 'react';
import { useParams } from 'react-router-dom';
import { HomeDetailsProvider } from '../contexts/HomeDetailsContext';
import { HomeAttachmentsProvider } from '../contexts/HomeAttachmentsContext';
import { HomeAreasProvider } from '../contexts/HomeAreasContext';
import { HomeRepairsProvider } from '../contexts/HomeRepairsContext';
import { ChatProvider } from '../contexts/ChatContext';
import HomeDetailsWithIntelligence from './HomeDetailsWithIntelligence';
import PropertyIntelligencePage from '../pages/PropertyIntelligencePage';
import { IntelligenceErrorBoundary } from './intelligence/IntelligenceErrorBoundary';
import AppTheme from '../theme/AppTheme';

/**
 * Wrapper component that provides all necessary contexts for the PropertyIntelligencePage
 */
export const PropertyIntelligenceWrapper: React.FC = () => {
  const { homeId } = useParams<{ homeId: string }>();

  if (!homeId) {
    return <div>Invalid home ID</div>;
  }

  return (
    <AppTheme>
      <HomeDetailsProvider homeId={homeId}>
        <HomeAreasProvider homeId={homeId}>
          <ChatProvider homeId={homeId}>
            <HomeAttachmentsProvider homeId={homeId}>
              <HomeRepairsProvider homeId={homeId}>
                <HomeDetailsWithIntelligence>
                  <IntelligenceErrorBoundary>
                    <PropertyIntelligencePage />
                  </IntelligenceErrorBoundary>
                </HomeDetailsWithIntelligence>
              </HomeRepairsProvider>
            </HomeAttachmentsProvider>
          </ChatProvider>
        </HomeAreasProvider>
      </HomeDetailsProvider>
    </AppTheme>
  );
};

export default PropertyIntelligenceWrapper;